var _excluded = ["fullWidth", "type", "variation", "isColoredBackground"],
    _excluded2 = ["title", "children", "type", "background", "fullWidth"];

var _templateObject;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import Copy from "@nib-components/copy";
import Heading from "@nib-components/heading";
import { Box, Columns, Column, Stack } from "@nib/layout";
import { colorWhite, formBoxShadow, boxShadowStandard } from "@nib-components/theme";
import { validTypeValues, validBackgroundValues } from "../types";
import { pickBackgroundColor, pickColor, renderIcon } from "../utils"; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var Wrapper = styled(function (_ref) {
  var fullWidth = _ref.fullWidth,
      type = _ref.type,
      variation = _ref.variation,
      isColoredBackground = _ref.isColoredBackground,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  box-sizing: border-box;\n  max-width: 100%;\n  width: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  border-left: 0.25rem solid ", ";\n\n  padding: 1.5rem;\n"])), function (props) {
  return props.fullWidth ? "100%" : "auto";
}, function (props) {
  return props.isColoredBackground ? pickBackgroundColor(props.type) : colorWhite;
}, boxShadowStandard || formBoxShadow, function (props) {
  return pickColor(props.type);
});

var SoftAlert = function SoftAlert(props) {
  var title = props.title,
      children = props.children,
      type = props.type,
      _props$background = props.background,
      background = _props$background === void 0 ? "white" : _props$background,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var isLight = background === "light";
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    fullWidth: fullWidth,
    isColoredBackground: isLight,
    type: type
  }, otherProps), /*#__PURE__*/React.createElement(Columns, {
    align: "center",
    verticalAlign: "top",
    space: 5
  }, /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    width: "2rem",
    justifyContent: "center"
  }, renderIcon(type, true))), /*#__PURE__*/React.createElement(Column, {
    flex: true
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 3
  }, title && /*#__PURE__*/React.createElement(Heading, {
    size: 4
  }, title), children && /*#__PURE__*/React.createElement(Copy, {
    measure: false,
    component: "div"
  }, children))))));
};

SoftAlert.displayName = "SoftAlert";
export default SoftAlert;